import React, { useState, useEffect, useRef } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Languages } from "lucide-react";
import { resolveTaal, isTweetalig, TAAL_LABELS } from "@/lib/taal";

const TALEN = ["nl", "en", "de"];

// Hook: start(land, actie) roept actie(taal) direct aan bij een eentalig land,
// of opent de taalpopup bij een tweetalig land (België/Zwitserland/Luxemburg).
export function useTaalActie() {
  const [open, setOpen] = useState(false);
  const [land, setLand] = useState("");
  const actieRef = useRef(null);
  const start = (land, actie) => {
    if (isTweetalig(land)) {
      setLand(land || "");
      actieRef.current = actie;
      setOpen(true);
    } else {
      actie(resolveTaal(land));
    }
  };
  const bevestig = (taal) => {
    setOpen(false);
    const a = actieRef.current;
    actieRef.current = null;
    if (a) a(taal);
  };
  return { open, setOpen, land, start, bevestig };
}

export function TaalKeuzeDialog({ open, onOpenChange, land, onKies, titel = "Kies de taal" }) {
  const [taal, setTaal] = useState(resolveTaal(land));
  useEffect(() => { if (open) setTaal(resolveTaal(land)); }, [open, land]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="taal-keuze-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Languages className="h-4 w-4 text-primary" /> {titel}
          </DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Dit is een klant in een tweetalig land{land ? ` (${land})` : ""}. Kies in welke taal het document
          en/of de e-mail opgesteld moet worden.
        </p>
        <Select value={taal} onValueChange={setTaal}>
          <SelectTrigger data-testid="taal-keuze-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {TALEN.map((t) => (
              <SelectItem key={t} value={t} data-testid={`taal-optie-${t}`}>{TAAL_LABELS[t]}</SelectItem>
            ))}
          </SelectContent>
        </Select>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} data-testid="taal-keuze-annuleer">Annuleren</Button>
          <Button onClick={() => onKies(taal)} data-testid="taal-keuze-bevestig">Doorgaan</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
